module.exports = __webpack_public_path__ + "static/media/S15.5a8726da.png";